import i18n from '@/lang/i18n'
import { Nullable } from '@/shared/types/app.types'

export enum StatisticalAnalysisFilterByEnum {
    JOB = 'JOB',
    SKILL = 'SKILL'
}

export interface StatisticalAnalysisFilterByStateCombo {
    id: number | string
    text: string
}

export interface StatisticalAnalysisFilterByStateFilters {
    selected: Nullable<StatisticalAnalysisFilterByStateCombo>
    list: StatisticalAnalysisFilterByStateCombo[]
}

export interface StatisticalAnalysisFilterByState {
    filterBy: StatisticalAnalysisFilterByStateFilters
    filter: StatisticalAnalysisFilterByStateFilters
    filterTimeSheet: StatisticalAnalysisFilterByStateFilters
    loading: boolean
}
export const initialStatisticalAnalysisFilterByState =
    (): StatisticalAnalysisFilterByState => ({
        filterBy: {
            selected: null,
            list: [
                { id: StatisticalAnalysisFilterByEnum.JOB, text: i18n.tc('statisticalAnalysis.filters.job') }
            // TODO In the first version it is not included
            // { id: StatisticalAnalysisFilterByEnum.SKILL, text: i18n.tc('statisticalAnalysis.filters.skill') }
            ]
        },
        filter: {
            selected: null,
            list: []
        },
        filterTimeSheet: {
            selected: null,
            list: []
        },
        loading: false
    })
